// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

/* Logger level

Level.OFF
Level.ERROR
Level.WARN
Level.INFO
Level.DEBUG
Level.LOG
*/
import { Level } from "angular2-logger/core";

export const environment = {
    production: true,
    c_domain: 'agentemasiv.com',
    namePA:'agentemasiv',
    apiUrl: 'https://api.agentemasiv.com/api/',
    recaptcha_site_key: '6Ldh0s4rAAAAANQsefbRt2ykE0KpBF-90nzs4NVy',
    logger: Level.LOG,
    ActivateGuard: true,
    pusher: {
      key: '3320997055f7cfe9f5aa', // helpdesk 
      cluster: 'us2',
    },
    enableVideocall: false,
    VIDEOSDK_API_KEY: '7ab2b28d-07f0-4fc7-b2c7-2e50c155f62f',
    VIDEOSDK_API_TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiI3YWIyYjI4ZC0wN2YwLTRmYzctYjJjNy0yZTUwYzE1NWY2MmYiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTczODI3NjU4OCwiZXhwIjoxODk2MDY0NTg4fQ.AqgSzPrJSV_vNPwsHhUpnPEhs_UvjaU_J_lUlj-L_Jo',
    chatBot:false,
    chatBotId:null,
    chatBotVersion:null,
};



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/environments/environment.ts